import api from './base'

export default {
  getAll (headers = null) {
    if (headers != null) {
      return api().get(`company/business_units`, { headers: headers })
    } else {
      return api().get(`company/business_units`)
    }
  },
  getById ({ id }) {
    return api().get(`company/business_units/${id}`)
  },
  getHeader ({ businessUnitId }) {
    return api().get(`company/business_units/${businessUnitId}/invoice_header`)
  },
  // vrni komentarje (vrjetno bom bolj rabu v appu)
  getComments ({ businessUnitId }) {
    return api().get(`company/business_units/${businessUnitId}/order_comments`)
  },
  // vrni komentar (vrjetno bom bolj rabu v appu)
  getComment ({ businessUnitId, commentId }) {
    return api().get(`company/business_units/${businessUnitId}/order_comments/${commentId}`)
  },
  // ce je poslan tudi id, potem je update, drugace je samo add
  setComment ({ businessUnitId, data }) {
    return api().put(`company/business_units/${businessUnitId}/order_comments`, data)
  },
  // odstranitev komentarja?
  deleteComment ({ businessUnitId, commentId }) {
    return api().delete(`company/business_units/${businessUnitId}/order_comments/${commentId}`)
  },
  deleteTableSessions ({ businessUnitId }) {
    return api().delete(`company/business_units/${businessUnitId}/table_sessions`)
  },
  // a ne bi bilo bolje, da bi vsak komentar drzal se neko listo pripadajocih kategorij?
  getCommentCategories ({ businessUnitId, orderCommentId }) {
    return api().get(`company/business_units/${businessUnitId}/order_comments/${orderCommentId}/categories`)
  },
  // nastavi kategoriji komentar z tem idjem.
  setCommentCategory ({ businessUnitId, categoryId, commentId }) {
    return api().put(`company/business_units/${businessUnitId}/categories/${categoryId}/order_comments`, { id: commentId })
  },
  deleteCommentCategory ({ businessUnitId, categoryId, orderCommentId }) {
    return api().delete(`company/business_units/${businessUnitId}/categories/${categoryId}/order_comments/${orderCommentId}`)
  },
  statusOrderingPermission ({ businessUnitId, status, headers }) {
    if (status === 0) {
      // disable ordering permission for business unit
      return api().delete(`company/business_units/${businessUnitId}/ordering`, { headers: headers })
    } else {
      // enable ordering permission for business unit
      return api().put(`company/business_units/${businessUnitId}/ordering`, {}, { headers: headers })
    }
  },
  statusTablesPermission ({ businessUnitId, status, headers }) {
    if (status === 0) {
      // disable tables permission for business unit
      return api().delete(`company/business_units/${businessUnitId}/table_work`, { headers: headers })
    } else {
      // enable tables permission for business unit
      return api().put(`company/business_units/${businessUnitId}/table_work`, {}, { headers: headers })
    }
  },
  getBusinessUnitPricing ({ businessUnitId, pricingId }) {
    let url = `company/business_units/${businessUnitId}/pricings/`
    if (pricingId) {
      url += `${pricingId}`
    }
    return api().get(url)
  },
  setBusinessUnitPricingTime ({ businessUnitId, data }) {
    return api().put(`company/business_units/${businessUnitId}/pricings`, data)
  },
  deleteBusinessUnitPricing ({ businessUnitId, pricingId }) {
    return api().delete(`company/business_units/${businessUnitId}/pricings/${pricingId}`)
  },
  setBusinessUnitPricingArticles ({ businessUnitId, data }) {
    return api().put(`company/business_units/${businessUnitId}/pricings/${data.pricingId}/articles`, data.items)
  },
  enableBusinessUnitPricing ({ businessUnitId, headers }) {
    return api().put(`company/business_units/${businessUnitId}/pricing`, {}, { headers: headers })
  },
  disableBusinessUnitPricing ({ businessUnitId, headers }) {
    return api().delete(`company/business_units/${businessUnitId}/pricing`, { headers: headers })
  },
  setPricingAsMain ({ businessUnitId, pricingId }) {
    return api().put(`company/business_units/${businessUnitId}/pricings/${pricingId}/main`)
  }
}
